import { useState } from "react";
import { Modal } from "antd";
import { ExpandAltOutlined } from "@ant-design/icons";
import { AnimatePresence, motion } from "framer-motion";

//STYLES
import { ContainerPrazo } from "./styles";
import { transition_default } from "../../../../../../utils";
import { DonutChartPrazosSvg } from "./components/chart";
import { DefaultTitle } from "../defaultTitle";

//CONST
const segmento_permitido = ['', 'Todos', 'Atividades'];

//PROPS
interface Props {
    dados_prazo: number[];
    qtd_prazos: number[];
    segmento: string;
}

export const Prazos: React.FC<Props> = ({ dados_prazo, qtd_prazos, segmento }) => {

    const [modalAberto, setModalAberto] = useState(false);

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <ContainerPrazo
                    layout
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ y: 90, opacity: 0, transition: { delay: 0, ease: [0, 0.71, 0.2, 1.01] } }}
                    transition={{ ...transition_default, delay: 0.2 }}
                    key={'prazos'}
                >
                    <DefaultTitle title="Pontualidade das Execuções" />
                    <ExpandAltOutlined
                        onClick={() => setModalAberto(true)}
                        style={{
                            fontSize: 14,
                            cursor: 'pointer',
                            color: '#999',
                            padding: 4,
                            borderRadius: 4,
                            transition: 'color 0.2s',
                            position: 'absolute',
                            right: 10,
                            top: 10
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#555')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#999')}
                    />

                    <div className="Prazo__chart">
                        <DonutChartPrazosSvg values={dados_prazo} quantidades={qtd_prazos} />
                    </div>

                    {/* <div className="Prazo__labels">
                        <div className="Prazo__labels__item">
                            <div className="Prazo__labels__item__circle" style={{ background: '#7ebc61' }} />
                            <span className="Prazo__labels__item__lebel">No prazo</span>
                        </div>
                        <div className="Prazo__labels__item">
                            <div className="Prazo__labels__item__circle" style={{ background: "#FFD700" }} />
                            <span className="Prazo__labels__item__lebel">Adiantado</span>
                        </div>
                        <div className="Prazo__labels__item">
                            <div className="Prazo__labels__item__circle" style={{ background: "#DC143C" }} />
                            <span className="Prazo__labels__item__lebel">Atrasado</span>
                        </div>
                    </div> */}

                    <Modal
                        open={modalAberto}
                        onCancel={() => setModalAberto(false)}
                        footer={null}
                        title="Pontualidade das Execuções"
                        width={500}
                        centered
                    >
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
                            <DonutChartPrazosSvg values={dados_prazo} quantidades={qtd_prazos} size={300} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 20, paddingBottom: 10 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#7ebc61' }} />
                                <span>No prazo</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#FFD700' }} />
                                <span>Adiantado</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#DC143C' }} />
                                <span>Atrasado</span>
                            </div>
                        </div>
                    </Modal>

                </ContainerPrazo>
            )}
        </AnimatePresence>
    )
};